import { styled } from "@mui/system";

const MainWrap = styled("div")(() => ({
  position: "relative",
  overflowX: "hidden",
}));

export { MainWrap };
